// extracted by mini-css-extract-plugin
export default {"f":"c238ef7ce5","main":"_05ce1a1302","btn":"_6071bd4e2b","w":"_9efa24425d","h":"_0d2e3a6472","lh25":"_50d81ec17a","wb":"baef0c4a07","b":"b88c688908","bx":"_3ef164e814"};